module.exports = __webpack_public_path__ + "static/img/Tyson-Frizell.fef4ddb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tyson-Frizell.jpg
// module id = Bgsx
// module chunks = 0